<template lang="pug">
v-card
  v-card-title.d-flex.justify-center.align-center(style='height:60px; font-weight:700; font-size:20px; letter-spacing:0.5px;')
    | {{ $t('DOCUMENT_AGENT.SAVE_AS_TEMPLATE_HEADER') }}
  v-card-text.pa-4
    v-form(ref='form')
      .d-flex.align-start.py-1(style='gap:4px;')
        .d-flex.align-center(style='width:80px; min-width:80px; height:40px; font-size:14px; color:#444444; letter-spacing:0.5px;')
          | {{ $t('DOCUMENT_AGENT.SAVE_AS_TEMPLATE_NAME') }}
        v-text-field(
          v-model='templateName'
          dense
          outlined
          hide-details='auto'
          :rules='nameRules'
          style='font-size:14px;'
        )
      .d-flex.align-center.py-1(v-if='isAdmin' style='gap:4px;')
        .d-flex.align-center(style='width:80px; min-width:80px; height:40px; font-size:14px; color:#444444; letter-spacing:0.5px;')
          | {{ $t('DOCUMENT_AGENT.SAVE_AS_TEMPLATE_STATUS') }}
        .d-flex.align-center(style='gap:4px;')
          span(style='font-size:14px; color:#666666; letter-spacing:0.5px;') {{ $t('DOCUMENT_AGENT.SAVE_AS_TEMPLATE_PRIVATE') }}
          v-switch.keep-white-thumb.template-switch(v-model='isPublic' hide-details dense flat inset :ripple="false" color='#14C6DE' style='margin:0; padding:0;')
          span(style='font-size:14px; color:#666666; letter-spacing:0.5px; margin-left:-8px;') {{ $t('DOCUMENT_AGENT.SAVE_AS_TEMPLATE_PUBLIC') }}
      .d-flex.align-start.py-1(style='gap:4px;')
        .d-flex.align-start(style='width:80px; min-width:80px; height:40px; font-size:14px; color:#444444; letter-spacing:0.5px; padding-top:8px;')
          | {{ $t('DOCUMENT_AGENT.SAVE_AS_TEMPLATE_DESC') }}
        v-textarea(
          v-model='templateDesc'
          dense
          outlined
          hide-details
          no-resize
          rows='3'
          :placeholder="$t('DOCUMENT_AGENT.SAVE_AS_TEMPLATE_DESC')"
          style='font-size:14px;'
        )
  v-card-actions(style='background-color:#F4F4F4; height:60px; padding:10px 24px;')
    v-spacer
    v-btn(
      outlined
      width='100'
      height='40'
      style='border:1px solid #888888; font-weight:600; color:#666666; font-size:16px;'
      :ripple='false'
      @click='onCancel'
    ) {{ $t('GENERAL.CANCEL') }}
    v-btn(
      width='100'
      height='40'
      color='#14C6DE'
      depressed
      dark
      style='font-weight:600; font-size:16px; margin-left:16px;'
      :ripple='false'
      :loading='saveLoading'
      @click='onSubmit'
    ) {{ $t('DOCUMENT_AGENT.SAVE_AS_TEMPLATE_SAVE_BTN') }}
  v-dialog(v-model='duplicateConfirmDialog' width='360' content-class='statusDialog')
    message-dialog(
      :message="$t('DOCUMENT_AGENT.SAVE_AS_TEMPLATE_DUPLICATE_MSG')"
      @emitMessageDialog='onConfirmDuplicate'
    )
</template>

<script>
import UpGPTPortalDataServices from '@/services/UpGPTPortalDataServices';
import messageDialog from '@/components/Dialog/messageDialog';

export default {
  name: 'SaveAsTemplateDialog',
  components: {
    messageDialog,
  },
  props: {
    docAgentId: {
      type: String,
      required: true,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      templateName: '',
      templateDesc: '',
      isPublic: false,
      saveLoading: false,
      duplicateConfirmDialog: false,
      existingTemplateNames: [],
      nameRules: [
        v => (v && v.trim().length > 0) || this.$t('DOCUMENT_AGENT.SAVE_AS_TEMPLATE_NAME_REQUIRED'),
      ],
    };
  },
  async created() {
    await UpGPTPortalDataServices.getDocumentAgentTemplateList().then(response => {
      this.existingTemplateNames = (response.data || []).map(t => t.agent_name);
    }).catch(() => {});
  },
  methods: {
    resetForm() {
      this.templateName = '';
      this.templateDesc = '';
      this.isPublic = false;
      this.$refs.form && this.$refs.form.resetValidation();
    },
    onCancel() {
      this.resetForm();
      this.$emit('emitSaveAsTemplateCancel');
    },
    onSubmit() {
      if (!this.$refs.form.validate()) return;
      const name = this.templateName.trim();
      if (this.existingTemplateNames.some(n => n === name)) {
        this.duplicateConfirmDialog = true;
        return;
      }
      this.callSaveApi();
    },
    onConfirmDuplicate(confirmed) {
      this.duplicateConfirmDialog = false;
      if (confirmed) {
        this.callSaveApi();
      }
    },
    async callSaveApi() {
      this.saveLoading = true;
      try {
        await UpGPTPortalDataServices.saveDocumentAgentAsTemplate(this.docAgentId, {
          agent_name: this.templateName.trim(),
          goal: this.templateDesc,
          is_public_document_agent: this.isPublic,
        });
        this.resetForm();
        this.$emit('emitSaveAsTemplateSuccess');
      } catch (e) {
        const msg = e?.response?.data?.detail || '儲存失敗，請稍後再試';
        this.$emit('emitSaveAsTemplateError', msg);
      } finally {
        this.saveLoading = false;
      }
    },
  },
};
</script>

<style scoped>
::v-deep .template-switch {
  margin-top: 10px !important;
  margin-left: 5px !important;
}
</style>
